module.exports = __webpack_public_path__ + "static/media/home-map.30841423.jpg";